module.exports = __webpack_public_path__ + "static/media/super_reforzada_simil_madera.b19d4ad1.jpg";